.label {
  cursor: pointer;
  padding-left: 4px;
  font-size: var(--bc-font-size-sm);
  line-height: 1;
  color: var(--bc-color-text);

  &.disabled {
    color: var(--bc-color-text-disabled);
    cursor: not-allowed;
  }

  &.sizeDefault {
    font-size: var(--bc-font-size);
  }
}
